import { SectionShell } from "../components/SectionShell";
import { SectionTitle, SectionSubtitle } from "../typography/Typography";
import { Card, CardContent } from "../components/Card";
import { OptimizedImage } from "../components/OptimizedImage";

export interface TeamMember {
  name: string;
  role?: string;
  bio?: string;
  photo?: string;
}

export interface TeamSectionProps {
  className?: string;
  title?: string;
  subtitle?: string;
  members: TeamMember[];
}

export function TeamSection({
  title,
  subtitle,
  members,
  className,
}: TeamSectionProps) {
  return (
    <SectionShell className={className} backgroundClassName="bg-surface">
      {(title || subtitle) && (
        <div className="text-center mb-12">
          {title && <SectionTitle>{title}</SectionTitle>}
          {subtitle && <SectionSubtitle className="mt-4">{subtitle}</SectionSubtitle>}
        </div>
      )}

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {members.map((member: TeamMember) => (
          <Card
            key={member.name}
            className="overflow-hidden h-full border border-[color:var(--color-text,#0f172a)]/12 bg-[var(--color-surface,#fff)] text-[var(--color-text,#0f172a)] shadow-sm-2 hover:shadow-md-2 transition"
          >
            {member.photo && (
              <div className="w-full aspect-[4/3] overflow-hidden">
                <OptimizedImage
                  src={member.photo}
                  alt={member.name}
                  aspectRatio="4/3"
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <CardContent className="p-6 space-y-3">
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="text-lg font-semibold">{member.name}</h3>
                  {member.role && (
                    <p className="text-sm" style={{ color: "var(--color-text,#0f172a)", opacity: 0.75 }}>
                      {member.role}
                    </p>
                  )}
                </div>
              </div>
              {member.bio && (
                <p className="text-sm" style={{ color: "var(--color-text,#0f172a)", opacity: 0.82 }}>
                  {member.bio}
                </p>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </SectionShell>
  );
}
